import tableView from './tableView';
export default {
  tableView
}